import "./BackgroundTab.css";
import React from "react";
import { IRpgBackground } from "../../../models/IRpgBackground";
import { IRpgCharacter } from "../../../models/IRpgCharacter";
import AppearancePanel from "./AppearancePanel";
import BackgroundPanel from "../../../components/Character/Background/BackgroundPanel";
import { IRpgAlignment } from "../../../models/IRpgAlignment";

const NONE_BACKGROUND: IRpgBackground = {
    Id: 0,
    Name: "None",
    Description: "You led an ordinary mundane life and nothing super eventful or meaningful ever happened to you or the people you knew.",
    Features: [ "Select a background to see details and apply its bonuses." ],
};

interface IBackgroundTabProps {
    isReadOnly: boolean;
    tempCharacter: IRpgCharacter;
    setTempCharacter: React.Dispatch<React.SetStateAction<IRpgCharacter>>;
    backgroundList: IRpgBackground[];
    selectedBackground: IRpgBackground | null;
    onSelectBackground: (bg: IRpgBackground | null) => void;
    alignmentList: IRpgAlignment[];
}

const BackgroundTab: React.FC<IBackgroundTabProps> = ({
    isReadOnly,
    tempCharacter,
    setTempCharacter,
    backgroundList,
    selectedBackground,
    onSelectBackground,
    alignmentList,
}) => {
    const onBackground_Select = (bg: IRpgBackground | null) => {
        if (isReadOnly) {
            return;
        }
        onSelectBackground(bg);
    };

    return (
        <div className="background-tab">
            <section className="background-tab__panel background-tab__panel--appearance">
                <header className="background-tab__panel-header">
                    <h3 className="background-tab__panel-title">Physical appearance</h3>
                </header>

                <AppearancePanel 
                    isReadOnly={isReadOnly}
                    tempCharacter={tempCharacter} 
                    setTempCharacter={setTempCharacter} 
                    alignmentList={alignmentList}
                />
            </section>

            <section className="background-tab__panel background-tab__panel--background">
                <header className="background-tab__panel-header">
                    <h3 className="background-tab__panel-title">Background selection</h3>
                </header>

                <BackgroundPanel
                    isReadOnly={isReadOnly}
                    backgroundList={backgroundList}
                    selectedBackground={selectedBackground}
                    noneBackground={NONE_BACKGROUND}
                    onSelectBackground={onBackground_Select}
                />
            </section>
        </div>
    );
};

export default BackgroundTab;
